// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"B3-z","dimensionLabel":"C3-z","styleChooserControlWrapper":"D3-z","styleChooserControl":"E3-z","disabled":"F3-z","giftCard":"G3-z","styleChooserText":"H3-z"};